import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

export default class DigitalSidebar extends Component {
    render() {
        return (
            <div className="widget widget-nav-menu">
                <ul className="widget-menu">
                    <li><NavLink to={process.env.PUBLIC_URL + '/library-itinfrastructure'}>IT Infrastructure</NavLink></li>
                    <li><NavLink to={process.env.PUBLIC_URL + '/library-eresources'}>E-Resources</NavLink></li>
                    <li><NavLink to={process.env.PUBLIC_URL + '/library-openaccessresources'}>Open Access Resources</NavLink></li>
                    <li><NavLink to={process.env.PUBLIC_URL + '/library-institutionmembership'}>Institution Membership</NavLink></li>
                    <li><NavLink to={process.env.PUBLIC_URL + '/library-plagiarism'}>Plagiarism</NavLink></li>
                    <li><NavLink to={process.env.PUBLIC_URL + '/library-videosurveillance'}>CCTV Surveillance</NavLink></li>
                    <li><a href="http://elearning.vtu.ac.in/econtent/index.php" target="_blank">VTU E-Content</a></li>
                    <li><NavLink to={process.env.PUBLIC_URL + '/library-nptl'}>NPTEL</NavLink></li>
                    <li><NavLink to={process.env.PUBLIC_URL + '/library-ndl'}>NDLI</NavLink></li>
                    <li><NavLink to={process.env.PUBLIC_URL + '/library-mapmy'}>Knimbus</NavLink></li>
                    <li><a href="https://drive.google.com/drive/folders/1U5oJPB7DF36FZD6hRudUad8g2t-e7lop?usp=sharing" target="_blank">VTU Question Papers</a></li>
                    <li><a href="https://drive.google.com/drive/folders/1Cs_RcD6sIuYPuY5MJ4nYkA34XJfOjipD" target="_blank">Project Reports List</a></li>
                </ul>
            </div>
        )
    }
}
